import React from 'react';

const DemoCTA = () => {
    const generateWhatsAppLink = () => {
        const phoneNumber = "+923204192824"; // Updated with Pakistan's country code
        const url = `https://wa.me/${phoneNumber}`;
        return url;
    };
    return (
        <div className=' absolute md:-top-40 -top-36 md:left-40 left-3 right-3 md:right-40'>
            <div className="container mx-auto w-full bg-blue-50 md:py-6 py-3 md:px-8 px-2 text-center md:text-start rounded-lg shadow-lg relative">
                {/* Decorative Elements */}
                <div className="absolute top-2 left-2">
                    <div className="bg-logo rounded-full h-2 w-2 mb-2"></div>
                    <div className="bg-[#373AC880] rounded-full h-1 w-1"></div>
                </div>
                <div className="absolute top-4 right-4">
                    <div className="bg-[#373AC880] rounded-full h-1 w-1 mb-1"></div>
                    <div className="bg-logo rounded-full h-2 w-2"></div>
                </div>

                {/* Content */}
                <div className="md:flex justify-between items-center md:p-6 p-3">
                    {/* Text Section */}
                    <div>
                        <p className="text-xl font-medium text-gray-800">Ready To Share a Project?</p>
                        <p className="md:text-2xl text-lg font-bold text-gray-800 md:py-0 py-2">
                            <span className="text-logo ">Schedule a Meeting Now!</span>
                        </p>
                    </div>

                    {/* Button */}
                    <button className='md:mt-0 mt-2'>
                        <a
                            href={generateWhatsAppLink()}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg"
                        >
                            Submit Requirement
                        </a>
                    </button>   
                </div>

                {/* More Decorative Elements */}
                <div className="absolute bottom-2 right-2">
                    <div className="bg-[#373AC880] rounded-full h-1 w-1 mb-1"></div>
                    <div className="bg-logo rounded-full h-2 w-2"></div>
                </div>
            </div>
            <div className="absolute bottom-4 left-4">
                    <div className="bg-[#373AC880] rounded-full h-1 w-1 mb-1"></div>
                    <div className="bg-logo rounded-full h-2 w-2"></div>
                </div>
        </div>
    );
};

export default DemoCTA;
